import { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { ShieldAlert } from 'lucide-react';
import { api } from '../App';
import { toast } from 'sonner';

const reasons = [
  ['bullying', 'Bullying'],
  ['harassment', 'Harassment'],
  ['discrimination', 'Discrimination or hate'],
  ['threats', 'Threats or intimidation'],
  ['sexual_content', 'Sexual or inappropriate content'],
  ['spam', 'Spam or scam'],
  ['other', 'Other safety concern'],
];

export default function SafetyReportDialog({ open, onOpenChange, subject, sourceType, sourceId }) {
  const [reason, setReason] = useState('harassment');
  const [details, setDetails] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) {
      setReason('harassment');
      setDetails('');
    }
  }, [open]);

  const submitReport = async () => {
    if (!subject?.id) {
      toast.error('Choose a participant to report');
      return;
    }
    setSubmitting(true);
    try {
      const res = await api.post('/safety/reports', {
        subject_user_id: subject.id,
        source_type: sourceType,
        source_id: sourceId,
        reason,
        details,
      });
      toast.success(res.data.message || 'Report sent to the safety team');
      onOpenChange(false);
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Could not send the report');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="safety-report-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><ShieldAlert size={20} /> Report a safety concern</DialogTitle>
          <p className="text-sm text-muted-foreground">
            Report {subject?.name || 'this participant'} for confidential review. Reports do not automatically penalize an account.
          </p>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="safety-reason">What happened?</Label>
            <select id="safety-reason" value={reason} onChange={(event) => setReason(event.target.value)} className="mt-1 h-10 w-full border bg-white px-3 text-sm">
              {reasons.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
            </select>
          </div>
          <div>
            <Label htmlFor="safety-details">Details for the safety team</Label>
            <Textarea id="safety-details" value={details} onChange={(event) => setDetails(event.target.value)} rows={4} placeholder="Describe what was said or done. Do not include passwords or payment information." />
          </div>
          <Button className="w-full" onClick={submitReport} disabled={submitting} data-testid="submit-safety-report">
            {submitting ? 'Sending report...' : 'Send Confidential Report'}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
